export default {
  KEY: '5JUVF3Y27ZYGH04E6YCBDRQI4V1OWH5S',
  IV: 'XF05D6RHK6UMTBAG'
};
